import type { SVGProps } from 'react';

const GooglePayIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" aria-hidden {...props}>
    <path
      fill="#EA4335"
      d="M12 5.04c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 1.72 14.97.72 12 .72 7.7.72 3.99 3.19 2.18 6.79l3.66 2.84C6.71 6.96 9.14 5.04 12 5.04Z"
    />
    <path
      fill="#4285F4"
      d="M23.28 12.27c0-.79-.07-1.54-.2-2.27H12v4.51h6.34c-.27 1.45-1.1 2.68-2.35 3.51l3.6 2.79c2.11-1.95 3.69-4.82 3.69-8.54Z"
    />
    <path
      fill="#FBBC05"
      d="M5.84 14.37a6.97 6.97 0 0 1 0-4.74L2.18 6.79a11.27 11.27 0 0 0 0 10.42l3.66-2.84Z"
    />
    <path
      fill="#34A853"
      d="M12 23.28c3.06 0 5.63-1.01 7.5-2.74l-3.6-2.79c-1 .67-2.28 1.07-3.9 1.07-2.86 0-5.29-1.92-6.16-4.51l-3.66 2.84C3.99 20.81 7.7 23.28 12 23.28Z"
    />
  </svg>
);

export default GooglePayIcon;
